import { Box } from '@mui/material'

export const APP_STORE_URL =
  'https://apps.apple.com/ca/app/lastseen-app/id6477953801'
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.lastseen'

/**
 * The official App Store / Google Play badge artwork, each wrapped in a plain
 * outbound link to the live store listing. `height` sets the badge height in px
 * (64 in the hero, 56 in the CTA).
 */
const StoreBadges = ({
  height = 64,
  gap = 20,
  justify = 'flex-start',
}: {
  height?: number
  gap?: number
  justify?: 'flex-start' | 'center'
}) => {
  const badges = [
    {
      url: APP_STORE_URL,
      img: 'app_store_badge.png',
      alt: 'Download on the App Store',
    },
    {
      url: GOOGLE_PLAY_URL,
      img: 'google_play_color.png',
      alt: 'Get it on Google Play',
    },
  ]
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: `${gap}px`,
        justifyContent: justify,
      }}
    >
      {badges.map((b) => (
        <a key={b.img} href={b.url} target="_blank" rel="noreferrer">
          <Box
            component="img"
            src={process.env.PUBLIC_URL + '/images/' + b.img}
            alt={b.alt}
            sx={{ height: `${height}px`, display: 'block', width: 'auto' }}
          />
        </a>
      ))}
    </Box>
  )
}

export default StoreBadges
